import React from 'react'
import { Heading } from '@scentregroup/ui'
import PropTypes from 'prop-types'
import Breadcrumb from '../../../components/breadcrumb'
import analyticsUtils from '../../../helpers/analytics-utils'
import analyticsHierarchy from '../filter/analytics-hierarchy'
import style from './index.scss'

const analyticsActionHierarchy = [
  analyticsUtils.actions.BREADCRUMB.ROOT,
  analyticsUtils.actions.BREADCRUMB.T1,
  analyticsUtils.actions.BREADCRUMB.T2,
  analyticsUtils.actions.BREADCRUMB.T3,
]

const handleClick = categoriesHierarchy => {
  const categories = analyticsHierarchy(categoriesHierarchy)
  return index => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PRODUCTS_BREADCRUMB,
      eventCategory: analyticsUtils.categories.BREADCRUMB_CLICK,
      eventAction: analyticsActionHierarchy[index],
      ...categories,
    })
  }
}

function mapCategories(categories, lastItemLink) {
  const clickHandler = handleClick(categories)
  const items = []
  let currentPath = ''
  for (let i = categories.length - 1; i >= 0; i--) {
    const category = categories[i]
    currentPath += `/${category.slug}`
    items.push({
      link: i === 0 && !lastItemLink ? undefined : currentPath,
      value: category.name,
      onClick: () => clickHandler(categories.length - 1 - i),
    })
  }

  return items
}

const ProductTitle = ({
  title,
  categoriesHierarchy = [],
  lastItemLink,
  className,
}) => (
  <div className={className}>
    <Heading className={style.title}>
      <p dangerouslySetInnerHTML={{ __html: title }} />
    </Heading>
    <Breadcrumb
      className={style.breadcrumb}
      items={mapCategories(categoriesHierarchy, lastItemLink)}
    />
  </div>
)

ProductTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  categoriesHierarchy: PropTypes.arrayOf(PropTypes.object).isRequired,
  lastItemLink: PropTypes.bool,
}

export default ProductTitle
